<div class="d-flex row-cols-12">
    <div class="col-12">
        <h3 class="title float-start" translate>Settings.Identity</h3>
    </div>
</div>

<div class="px-4 my-2 mb-1 d-table col-12">
    <span class="pt-5 pb-2 col-12"
        translate="Settings.SecuritySection.Identity.IdentificationProviders"><app-info-button
            labelName="Settings.SecuritySection.Identity.IdentificationProvidersTooltip"
            [url]="IdentificationProviderUrl" placement="bottom"></app-info-button></span>
    <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <ul class="mt-2 w-100 list-group">
            <li class="list-group-item subheader d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-6"><span translate="Settings.SecuritySection.Identity.Provider"></span></div>
                </div>
            </li>


            <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_IdP_Sms">
                <li class="list-group-item d-block py-1">
                    <div class="row w-100 d-flex align-items-center">
                        <div class="col-12 text-truncate float-none form-check form-switch">
                            <input class="float-none switch-form-default form-check-input items" type="checkbox"
                                role="switch" id="smsOtp" [checked]="true" 
                                [disabledByPermission]="permissionEnum.Perm_IdP_Sms">
                            <label class="col-10" for="smsOtp"
                                translate="Settings.SecuritySection.Identity.SMSOTP"></label>
                        </div>
                    </div>
                </li>

            </app-hide-by-permission-wrapper>

            <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_IdP_Whatsapp">
                <li class="list-group-item d-block py-1">
                    <div class="row w-100 d-flex align-items-center">
                        <div class="col-12 text-truncate float-none form-check form-switch">
                            <input class="float-none switch-form-default form-check-input items" type="checkbox"
                                role="switch" id="whatsappAuthentication" (click)="updateIdentificationmethods($event)"
                                [checked]="identificationmethods === 'SMSorWhatsApp'"
                                [disabledByPermission]="permissionEnum.Perm_IdP_Whatsapp">
                            <label class="col-10" for="whatsappAuthentication"
                                translate="Settings.SecuritySection.Identity.WhatsappAuthentication"></label>
                        </div>
                    </div>
                </li>

            </app-hide-by-permission-wrapper>

            <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_IdP_IDIN">
                <li class="list-group-item d-block py-1">
                    <div class="row w-100 d-flex align-items-center">
                        <div class="col-12 text-truncate float-none form-check form-switch">
                            <input class="float-none switch-form-default form-check-input items" type="checkbox"
                                role="switch" id="idin" (click)="updateIdin($event)" [checked]="idin?.useIdin"
                                [disabledByPermission]="permissionEnum.Perm_IdP_IDIN">
                            <label class="col-10" for="idin" translate="Settings.SecuritySection.Identity.IDIN"></label>
                        </div>
                    </div>
                </li>

            </app-hide-by-permission-wrapper>

            <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_IdP_Vidua_Authentication">
                <li class="list-group-item d-block py-1">
                    <div class="row w-100 d-flex align-items-center">
                        <div class="col-12 text-truncate float-none form-check form-switch">
                            <input class="float-none switch-form-default form-check-input items" type="checkbox"
                                role="switch" id="viduaAuthentication" (click)="updateviduaAuthentication($event)" [checked]="viduaAuthentication"
                                [disabledByPermission]="permissionEnum.Perm_IdP_Vidua_Authentication">
                            <label class="col-10" for="viduaAuthentication" translate="Settings.SecuritySection.Identity.ViduaAuthentication"></label>
                        </div>
                    </div>
                </li>

            </app-hide-by-permission-wrapper>

            <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_IdP_Vidua_Identification">
                <li class="list-group-item d-block py-1">
                    <div class="row w-100 d-flex align-items-center">
                        <div class="col-12 text-truncate float-none form-check form-switch">
                            <input class="float-none switch-form-default form-check-input items" type="checkbox"
                                role="switch" id="ViduaIdentification" (click)="updateViduaIdentification($event)" [checked]="viduaIdentification"
                                [disabledByPermission]="permissionEnum.Perm_IdP_Vidua_Identification">
                            <label class="col-10" for="ViduaIdentification" translate="Settings.SecuritySection.Identity.ViduaIdentification"></label>
                        </div>
                    </div>
                </li>

            </app-hide-by-permission-wrapper>
        </ul>
    </div>
</div>